export const getBooleanFromString = (str?: string | null, defaultValue?: boolean): boolean => {
    switch (str) {
        case "false": {
            return false;
        }
        case "true": {
            return true;
        }
        default:
            if (typeof defaultValue === "boolean") {
                return defaultValue;
            } else {
                return false;
            }
    }
};
